export default "__VITE_ASSET__Du7IqSS$__"